// @flow
export const DASHBOARD_ACTION_TYPES: {GET_AVERAGE_MODULE_RESULTS: 'GET_AVERAGE_MODULE_RESULTS'} = {
    GET_AVERAGE_MODULE_RESULTS: 'GET_AVERAGE_MODULE_RESULTS',
};
export const DASHBOARD_MODULE_NAME = 'dashboard';
